import request from "@/components/common/utils/request.js"


export function api_page_monitoring2(params) {
	return request({
		url: '/api/monitoring2/keywords/page',
		method: 'get',
		params :params
	})
}

export function api_add_monitoring2(obj) {
	return request({
		url: '/api/monitoring2/keywords/add',
		method: 'post',
		data : obj
	})
}


export function api_del_monitoring2(id) {
	return request({
		url: '/api/monitoring2/keywords/del',
		method: 'get',
		params :{
			taskId : id
		}
	})
}


export function api_updateConfig_monitoring2(params){
	return request({
		url: '/api/monitoring2/keywords/updateConfig',
		method: 'get',
		params :params
	})
}

export function api_renewal_monitoring2(ids,num){
	return request({
		url: '/api/monitoring2/keywords/renewal',
		method: 'get',
		params : {
			taskIds : ids,
			renewalNum : num
		}
	})
}

export function api_addMonitoring_monitoring2(data) {
	return request({
		url: '/api/monitoring2/keywords/addMonitoring',
		method: 'post',
		data : data
	})
}

export function api_keywordsTrends_monitoring2(data) {
	return request({
		url: '/api/monitoring2/keywords/keywordsTrends',
		method: 'get',
		params : data
	})
}

export function api_keywordsResult_monitoring2(data) {
	return request({
		url: '/api/monitoring2/keywords/keywordsResult',
		method: 'get',
		params : data
	})
}

export function api_keywordsDataList_monitoring2(data) {
	return request({
		url: '/api/monitoring2/keywords/keywordsDataList',
		method: 'get',
		params : data
	})
}

export function api_keywordsRelatedList_monitoring2(data) {
	return request({
		url: '/api/monitoring2/keywords/keywordsRelatedList',
		method: 'get',
		params : data
	})
}

// asin
/**
 *
 * @param data = { taskId : String,asins : Array }
 * @returns {*}
 */
export function api_addAsin_monitoring2(data) {
	return request({
		url: '/api/monitoring2/asin/add',
		method: 'post',
		data : data
	})
}

export function api_asinInfoList_monitoring2(params) {
	return request({
		url: '/api/monitoring2/asin/asinInfoList',
		method: 'get',
		params : params
	})
}

export function api_asinRankTrends_monitoring2(obj) {
	return request({
		url: '/api/monitoring2/asin/asinRankTrends',
		method: 'get',
		params : obj
	})
}

export function api_asinDataPage_monitoring2(obj) {
	return request({
		url: '/api/monitoring2/asin/asinDataPage',
		method: 'get',
		params : obj
	})
}

//
export function api_delAsin_monitoring2(groupId,asins) {
	return request({
		url: '/api/monitoring2/asin/del',
		method: 'get',
		params : {
			groupId : groupId,
			asins :asins
		}
	})
}

/**
 *
 * @param obj [page,pageSize,dataId]
 * @returns {*}
 */
export function api_asinDataByDataId_monitoring2(obj) {
	return request({
		url: '/api/monitoring2/asin/asinDataByDataId',
		method: 'get',
		params : obj
	})
}

//group

export function api_groupPage_monitoring2(obj) {
	return request({
		url: '/api/monitoring2/keywords/groupPage',
		method: 'get',
		params : obj
	})
}

export function api_groupDel_monitoring2(groupId) {
	return request({
		url: '/api/monitoring2/keywords/group/del',
		method: 'get',
		params : {
			groupId : groupId
		}
	})
}
export function api_groupRename_monitoring2(groupId,rename) {
	return request({
		url: '/api/monitoring2/keywords/group/rename',
		method: 'get',
		params : {
			groupId : groupId,
			rename : rename
		}
	})
}


